import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import Pusher from "pusher-js";
import { connect } from "react-redux";
import moment from "moment";
import { useHistory, useLocation } from "react-router";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { ACTIONS } from "../../interfaces/actionTypes/loginTypes";
import SecureStorage from "../../config/SecureStorage";
var jwt = require("jsonwebtoken");
let userGroup = "";


const PusherComponent = ({ userDetails, getUserDetails }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [localData, setLocalData] = useState(localStorage.notificationData);
  const [userDetail, setUserDetail] = React.useState({
    userName: null,
    authToken: null,
  });
  const location = useLocation();
  const audio = new Audio(
    "https://static.redcliffelabs.com/media/WhatsAppNotification.mp3"
  );

  useEffect(() => {
    const checkLoginInterval = setInterval(() => {
      const authToken = SecureStorage.getItem("token");
      const userName = SecureStorage.getItem("username");
      if (authToken && userName) {
        setUserDetail({
          authToken,
          userName,
        });
        clearInterval(checkLoginInterval);
      }
    }, 1000);
  }, []);

  useEffect(() => {
    Notification.requestPermission().then().catch();
    if (userDetail.authToken && userDetail.userName) {
      const apiEndpoint = `${process.env.REACT_APP_API_PATH}api/v1/auth`;
      Pusher.logToConsole = true;
      var pusher = new Pusher(`${process.env.REACT_APP_CALLPOPUP_KEY}`, {
        cluster: "ap2",
        forceTLS: true,
        // Channel authorization
        channelAuthorization: {
          endpoint: `${apiEndpoint}/pusher/auth/`,
          headers: {
            Authorization: `Token ${userDetail.authToken}`,
          },
        },
      });

      var channel = pusher.subscribe(`private-${userDetail?.userName}`);

      console.log(channel,"channelchannel")

      const decoded = jwt.decode(userDetail.authToken);
      userGroup = decoded?.user_group;

      channel.bind("offline_new_chat", function (data) {
        dispatch({ type: ACTIONS.WHATSAPP_DATA_FROM_PUSHER, payload: data });
        console.log(data,"datadatadatadata")
        NotificationManager.info(handleWhatsapp(data), ``, 15000);
        audio.play();
      });

      channel.bind("offline_chat_assigned", function (data) {
        dispatch({ type: ACTIONS.CHAT_ASSIGNED_FROM_PUSHER, payload: data });
        NotificationManager.success(handleWhatsapp(data), ``, 15000);
        audio.play();
      });
    }
  }, [userDetail]);

 

  const handleWhatsapp = (data) => {
    return (
      <div>
        <p>
          <span style={{ color: "black" }}>Lead: {data?.id}</span>
          <br />
          <b>
            {" "}
            {data?.patient_name} {": "} {data?.message}
          </b>
          <br />
          <b style={{ color: "black" }}>
            {new Date(data?.latest_chat_created_at).toLocaleString()}
          </b>
        </p>
      </div>
    );
  };



  return <span></span>;
};
const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, {})(PusherComponent);
